export const seachangeStandout = '#ffffff';
export const seachangeTextAlpha30 = 'rgba(87, 87, 87, 0.3)';
export const seachangeTextAlpha15 = 'rgba(87, 87, 87, 0.15)';
export const seachangeTextAlpha5 = 'rgba(87, 87, 87, 0.05)';
